export interface ServiceData {
  _id: number;
  total: number;
  isDownloading: boolean;
  isDownloaded: boolean;
  projectId?: string;
  shouldReset?: boolean;
  syncKey?: string;
}

/**
 * A downloaded collection that records another project than the configured
 * one. A collection stored before owners were recorded (no `projectId`) counts
 * as the configured project's, as it did then: clearing it would lose the
 * offline data of every user on the first start after the release. It records
 * its project with its next download; a project switch clears it anyway.
 */
export function isDownloadedForAnotherProject(
  status: Pick<ServiceData, 'isDownloaded' | 'projectId'> | undefined,
  projectId: string | undefined
): boolean {
  return Boolean(status?.isDownloaded && projectId && status.projectId && status.projectId !== projectId);
}
